import { createContext, useContext, type ReactNode } from "react"
import type { UsePermitRequestActionsResult } from "../pages/permit-request/hooks/usePermitRequestActions"

type PermitRequestActionsContextValue = UsePermitRequestActionsResult

const PermitRequestActionsContext = createContext<PermitRequestActionsContextValue | null>(null)

interface PermitRequestActionProviderProps {
  value: PermitRequestActionsContextValue
  children: ReactNode
}

export const PermitRequestActionProvider = ({
  value,
  children,
}: PermitRequestActionProviderProps) => (
  <PermitRequestActionsContext.Provider value={value}>
    {children}
  </PermitRequestActionsContext.Provider>
)

export const usePermitRequestActionsContext = (): PermitRequestActionsContextValue => {
  const ctx = useContext(PermitRequestActionsContext)
  if (!ctx) {
    throw new Error("usePermitRequestActionsContext must be used within PermitRequestActionProvider")
  }
  return ctx
}
